export default class SettingsHelper {
  public JSONSettings: Record<string, string>

  constructor(JSONSettings: string) {
    this.JSONSettings = JSON.parse(JSONSettings)
    console.info(`building settingChecker with ${JSONSettings}`)
  }

  check(permission: string): string {
    if (!Object.keys(this.JSONSettings).includes(permission)) {
      console.error(`SettingsHelper - setting "${permission}" does not exist`)
      return ''
    }
    console.info(
      `SettingsHelper - getting ${permission} returns "${this.JSONSettings[permission]}"`,
    )
    return this.JSONSettings[permission]
  }
}
